import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Office from './components/Office';
import Staff from './components/Staff';
import RegistrationForm from './components/RegistrationForm';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <div className="section-wrapper section-primary">
          <Hero />
        </div>
        <div className="section-wrapper section-secondary">
          <Services />
        </div>
        <div className="section-wrapper section-primary">
          <Office />
        </div>
        <div className="section-wrapper section-secondary">
          <Staff />
        </div>
        <div className="section-wrapper section-primary">
          <section id="registration" className="registration-section">
            <div className="container">
              <div className="section-header">
                <h2 className="section-title">Start Your Journey to a Perfect Smile</h2>
                <p className="section-subtitle">
                  Ready to transform your smile? Complete your new patient registration below to get started
                  with your personalized orthodontic treatment plan.
                </p>
              </div>
              <RegistrationForm />
            </div>
          </section>
        </div>
        <div className="section-wrapper section-secondary">
          <section id="contact" className="contact-section">
            <div className="container">
              <div className="section-header">
                <h2 className="section-title">Have Questions? We're Here to Help</h2>
                <p className="section-subtitle">
                  Whether you need more information about our treatments, have insurance questions,
                  or want to schedule a consultation, we're ready to assist you.
                </p>
              </div>
              <ContactForm />
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
